export const uk = {
    'currency-cost-shows': '{currency} за тысячу показов',
    'rate-note': 'Максимальная ставка для новых и измененных условий показа'
};
